import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';

import content from '../lib/i18n';
const i18n = content('app/components/disclosure');

import {
  Logos,
  Logo,
  Title,
  Content,
  ButtonContainer,
  Confirm,
} from './redux/components/styles/disclosure';

// currently this disclosure only supp`orts venmo campaign
// however, this can be extended as a feature for any campaign
export default class Disclosure extends Component {
  constructor(props) {
    super(props);

    // TODO decice what parameters to use for `device`
    const show =
      this.props.type === 'venmo' &&
      this.props.device.toUpperCase() !== 'MOBILE';
    this.state = {
      showModal: show,
    };

    this.close = this.close.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }

  renderModalBody() {
    const disclosureType = 'venmo';

    const disclosureTitle = i18n(`${disclosureType}.disclosure.title`);
    const disclosureContent = i18n(`${disclosureType}.disclosure.content`);
    const disclosureButton = i18n(`${disclosureType}.disclosure.button`);

    let partner;
    if (this.props.cobrandedLogo) {
      partner = <Logo src={this.props.cobrandedLogo} />;
    }
    const paypal = (
      <Logo src='https://www.paypalobjects.com/webstatic/i/logo/rebrand/ppcom.svg' />
    );

    return (
      <div>
        <Logos>
          {partner}
          {paypal}
        </Logos>
        <Title>{disclosureTitle}</Title>
        <Content>{disclosureContent}</Content>
        <ButtonContainer>
          <Confirm onClick={this.close} className='btn btn-primary'>
            {disclosureButton}
          </Confirm>
        </ButtonContainer>
      </div>
    );
  }

  render() {
    const modalBodyStyle = {
      backgroundColor: 'white',
      borderRadius: '10px',
      boxShadow: '0 5px 20px 0 rgba(0, 0, 0, 0.1)',
    };

    return (
      <Modal
        show={this.state.showModal}
        onHide={this.close}
        dialogClassName='pp-modal'
      >
        <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header>
        <Modal.Body>{this.renderModalBody()}</Modal.Body>
      </Modal>
    );
  }
}
